module.exports = __webpack_public_path__ + "img/close_cross.a56b22e6.svg";